export { SettingsPage } from './views/SettingsPage';
